<script>
  export default {
    name: 'agent-details',
    data() {
    return {
      agent: [],
      agency:[],
      user:[],
      childMessage: '',
      approved:false,
        error:""
      };
  },
    props: {
        visible: {
            required: true
        },
        agentUuid:{
            required:true
        },
        childMessage:{
            required:true
        }
    },
    mounted() {
    this.getAgentDetails(this.agentUuid);
  },
    methods:{
        formSubmit(){
            if(this.childMessage==null){
                this.error="nothing entered";
            }else if(this.childMessage.length<5){
                this.error="invalid"
            }
        },
        notApprove(){
            this.$emit('agentPending', this.approved);
        },
         onClick(imgUrl) {
             window.open(imgUrl);
            //   axios({
            // url: imgUrl,
            // method: 'GET',
            //      responseType: 'blob', // important
            // }).then((response) => {
            // const url = window.URL.createObjectURL(new Blob([response.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', 'file.pdf');
            // document.body.appendChild(link);
            // link.click();
            // });
          },
        childAgentApprove (event) {
            if(this.childMessage==null){
                this.error="The Message Must be at Least 10 characters";
            }else if(this.childMessage.length<10){
                this.error="The Message Must be at Least 10 characters";
            }else{
                this.approved=true;
                this.$emit('childToParent', this.childMessage);
                this.$emit('agentApproval', this.approved);
            }
    },
        childAgentReject(event){ if(this.childMessage==null){
            this.error="The Message Must be at Least 10 characters";
        }else if(this.childMessage.length<10){
            this.error="The Message Must be at Least 10 characters";
        }else{
            this.$emit('childToParent', this.childMessage);
            this.$emit('agentRejection', this.approved);
        }
        },
        async getAgentDetails(uuid){
            try{
                axios
                 .post("/api/agent/detail/" + uuid, {
                    accessToken: localStorage.getItem("access_tocken"),
                })
                .then((response) => {
                 if (response.data.status) {
                this.agent=response.data.data.data;
                this.agency=response.data.data.data.agency_information[0];
                this.user=response.data.data.data.users[0];
                }
                 else{
                     var str = response.data.message;
                     var jsonParse = JSON.parse(str);
                     this.errorCheck(jsonParse);
                 }
                })
                .catch((error) => {
                    console.log(error.message);
                        });
            } catch (err) {
                    console.log(err);
                }
        }
    },
      errorCheck(obj) {
          if(obj.statusCode == 403){
              this.visible=true;
              this.message="Access Permission Denied";
              this.errors = obj.message;
          }else if (obj.error) {
              this.errors = obj.message;
          } else if (obj.message == "Token has expired") {
              this.$swal.fire({
                  title: 'LogOut!',
                  text: 'Token Has Expired',
                  icon: 'error',
                  toast:'true',
                  position: 'top-end',
              });
              this.$router.push({ name: "logout" });
          } else if (
              obj.message !== "Token has expired" &&
              obj.message !== "The given data was invalid."
          ) {
              this.errors = obj.message;
          } else if (obj.message == "The given data was invalid.") {
              this.errors = obj.errors;
          } else {
              this.flashMessage.show({
                  time: 5000,
                  status: "error",
                  title: "Error",
                  message: "Problem in data save",
              });
          }
      },
};
</script>

<template>
    <div class="modal" :class="{show:visible}">
        <div class="modal_content" :class="{show:visible}">
            <div class="modal_body">
               <button type="button" v-on:click="notApprove" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                    <div class="table-responsive" v-if="agency!=undefined">
                        <h4>Agency Information</h4>
                <table class="table-responsive table-striped">
                    <tr>
                        <td><img v-bind:src="agency.agency_logo" alt="logo"></td>

                    </tr>
                    <tr>
                        <td>Name</td>
                        <td v-if="agency.agency_name != null">{{agency.agency_name}}</td>
                        <td>Civil Aviation Certificate No.</td>
                        <td v-if="agency.civil_aviation_certificate_no != null">{{agency.civil_aviation_certificate_no}}</td><td v-else> N/A</td>

                    </tr>
                    <tr>
                        <td>Iata No.</td>
                        <td v-if="agency.iata_no != null">{{agency.iata_no}}</td><td v-else> N/A</td>
                        <td>Civil Aviation Certificate</td>
                        <td v-if="agency.civil_aviation_certificate_document != null">
                            <button class="btn btn-link" @click.prevent="onClick(agency.civil_aviation_certificate_document)">download</button>
                        </td>
                        <td v-else>
                            N/A
                        </td>


                    </tr>
                    <tr>
                        <td>Trade Licence No.</td>
                        <td v-if="agency.trade_license_no !=null">{{agency.trade_license_no}}</td>
                        <td v-else>
                            N/A
                        </td>
                        <td>Management Full Name</td>
                        <td v-if="agency.management_full_name != null">{{agency.management_full_name}}</td>
                        <td v-else>
                            N/A
                        </td>

                    </tr>
                    <tr>

                        <td>Postal Code</td>
                        <td v-if="agency.postal_code != null">{{agency.postal_code}}</td><td v-else> N/A</td>
                        <td>Management Ownership Title</td>
                        <td v-if="agency.management_ownership_title != null">{{agency.management_ownership_title}}</td><td v-else> N/A</td>

                    </tr>
                    <tr>

                        <td>Address</td>
                        <td v-if="agency.address != null">{{agency.address}}</td><td v-else>N/A</td>
                        <td>Management Phone No.</td>
                        <td v-if="agency.management_phone_number != null">{{agency.management_phone_number}}</td><td v-else>N/A</td>
                    </tr>
                     <tr>
                        <td>Website</td>
                        <td v-if="agency.website != null">{{agency.website}}</td><td v-else>N/A</td>
                         <td>Management Email</td>
                         <td v-if="agency.management_email != null">{{agency.management_email}}</td><td v-else>N/A</td>

                    </tr>
                     <tr>
                        <td>Fax</td>
                        <td v-if="agency.fax_no != null">{{agency.fax_no}}</td><td v-else>N/A</td>
                         <td>Contact Person Full Name</td>
                         <td v-if="agency.contact_person_full_name != null">{{agency.contact_person_full_name}}</td><td v-else>N/A</td>

                    </tr>
                    <tr>
                        <td>City</td>
                        <td v-if="agency.city != null">{{agency.city}}</td><td v-else>N/A</td>
                        <td>Contact Person Email</td>
                        <td v-if="agency.contact_person_email != null">{{agency.contact_person_email}}</td><td v-else>N/A</td>
                    </tr>
                    <tr>

                        <td>Country</td>
                        <td v-if="agency.country != null">{{agency.country}}</td><td v-else>N/A</td>
                        <td>Contact Person Phone No.</td>
                        <td v-if="agency.contact_person_phone_number != null">{{agency.contact_person_phone_number}}</td><td v-else>N/A</td>

                    </tr>
                    <tr>

                    </tr>
                    <tr>

                    </tr>

                </table>
                    </div>
                <div v-else>
                    <h4>Agency Info Not Available</h4>
                </div>
                    <div>
                        <h4>Agent Information</h4>
                        <table class="table-responsive">
                        <tr>
                            <td>First Name</td>
                            <td>{{agent.first_name}}</td>

                            <td>Country Code</td>
                            <td>{{agent.country_code}}</td>
                        </tr>
                        <tr>
                            <td>Last Name</td>
                            <td>{{agent.last_name}}</td>

                             <td>Country</td>
                            <td>{{agent.country}}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>{{agent.email}}</td>

                            <td>Currency</td>
                            <td>{{agent.currency}}</td>
                        </tr>
                        <tr>
                            <td>Phone No</td>
                            <td>{{agent.phone_code}}{{agent.phone_number}}</td>

                            <td>City</td>
                            <td>{{agent.city}}</td>
                        </tr>
                        <tr>
                            <td>Gender</td>
                            <td>{{agent.gender}}</td>

                            <td>Markup Amount</td>
                            <td>{{agent.markup_amount}}</td>
                        </tr>
                        <tr>
                            <td>Postal Code</td>
                            <td>{{agent.postal_code}}</td>

                            <td>Markup Type</td>
                            <td>{{agent.markup_type}}</td>
                        </tr>
                            <tr>
                                <td>Language</td>
                                <td>{{agent.language}}</td>
                            </tr>
                        </table>
                    </div>
                    <div>
                        <h4>User Information</h4>
                        <table class="table-responsive">
                             <tr>
                            <td>First Name</td>
                            <td>{{user.first_name}}</td>

                            <td>Display Picture</td>
                            <td><img v-bind:src="user.display_picture" alt="Picture"></td>
                        </tr>
                         <tr>
                            <td>Last Name</td>
                            <td>{{user.last_name}}</td>

                            <td>Country Code</td>
                            <td>{{user.country_code}}</td>
                        </tr>
                         <tr>
                            <td>Email</td>
                            <td>{{user.email}}</td>

                            <td>Country</td>
                            <td>{{agent.country}}</td>
                        </tr>
                         <tr>
                            <td>Phone No</td>
                            <td>{{user.phone_code}}{{user.phone_number}}</td>

                            <td>Account Status</td>
                            <td>{{user.status}}</td>
                        </tr>
                         <tr>
                            <td>Gender</td>
                            <td>{{user.gender}}</td>
                        </tr>
                        </table>
                    </div>

        <div>
            <div v-if="error" class="font-bold mb-4 text-sm">
                {{ error }}
            </div>
            <div>
                <div class="form-group">
                    <label for="child-input">Approval/Rejection Reason</label>
                    <input id="child-input" class="form-control col-6" placeholder="Enter your approval/rejection reason" type="text" name="msg" v-model="childMessage" :class="{ 'is-invalid': this.error }">
                </div>

            </div>
            <div class="agent-approve-button">
                <button type="submit" class="btn btn-primary btn-small" name="button" v-on:click="childAgentApprove"><i class="fa fa-check-circle"></i>Approve Agent</button>
                <button v-on:click="childAgentReject" type="button" class="btn btn-danger btn-small"><i class="fa fa-times-circle"></i>Reject</button>
            </div>
    </div>
            </div>
        </div>
    </div>

</template>
<style scoped>
template{
  overflow-y: hidden;
}
.modal{
    height: calc(110vh - 56px);
  overflow-y: auto;
    position:fixed;
    display: flex;
    align-items: self;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background:rgba(0,0,0,0.4);
    visibility: hidden;
    opacity: 0;

}
.modal.show{
    visibility:visible;
    opacity:1;
}
.modal_content{
    min-width: 370px;
    width:auto;
    background: #fff;
    margin:auto;
    visibility: hidden;
    opacity:0;
    width: 50%;
    min-height: 400px;
    height: auto;
    /* overflow: scroll; */
    padding: 2%;

}
.show.modal_content{
    visibility:visible;
    opacity:1;
}
/*.table th, .table td {
    padding: 0.35rem;
    vertical-align: top;
    border-top: 1px solid #eff2f7;
}*/
.modal_body{
    padding:13px;
}
.modal_body > div{
    padding-bottom: 4%;
}

table > tr >td {
    padding-right: 4%;
    height: 30px;
    /*text-align: center;*/
    vertical-align: baseline;
}
table > tr >td >img{
    width: 70px;
}
.agent-approve-button{
    padding-top: 3%;
}
table>tr>td{
    width:30%;
    height:30px;
}
table>tr>td:nth-child(odd) {
    font-weight: 600;
}
.table-responsive img{
    width:60px;
}
/*tr>td:nth-child(even) {background-color: #f2f2f2;}*/
</style>
